import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  submenuNavLink: {
    display: 'flex',
    width: '30px',
    height: '30px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '15px',

    '&:hover': {
      backgroundColor: '#424242',
    },
  },

  editGameIcon: {
    color: '#ffffff',
  },
});
